export default __webpack_public_path__ + "icon_request_a_quote.svg";